/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import { MatIcon } from './icon';
import { ICON_REGISTRY_PROVIDER } from './icon-registry';
var MatIconModule = (function () {
    function MatIconModule() {
    }
    MatIconModule.decorators = [
        { type: NgModule, args: [{
                    imports: [MatCommonModule],
                    exports: [MatIcon, MatCommonModule],
                    declarations: [MatIcon],
                    providers: [ICON_REGISTRY_PROVIDER],
                },] },
    ];
    /**
     * @nocollapse
     */
    MatIconModule.ctorParameters = function () { return []; };
    return MatIconModule;
}());
export { MatIconModule };
function MatIconModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatIconModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatIconModule.ctorParameters;
}
//# sourceMappingURL=icon-module.js.map